<template>
  <data-table
    :columns="queryColumns"
    fieldName="questions"
    :query="QUESTIONS"
    placeholder="Search by Name"
    :orderable="true"
    @ordered="onQuestionsOrdered"
    :params="{ campaignId: campaignId }"
  >
    <span slot="filter" class="pull-right">
      <router-link
        tag="button"
        class="btn btn-info add-button"
        type="button"
        :to="{ name: 'NewQuestion', params: { id: String(campaignId) } }"
      >
        <i class="mdi mdi-playlist-plus"></i> Add
      </router-link>
    </span>
    <span slot="mandatory" slot-scope="props">
      {{ props.row.mandatory ? 'Required' : 'Optional' }}
    </span>
    <span slot="created" slot-scope="props">
      {{ props.row.created | moment("MMM Do YYYY, h:mm:ss a") }}
    </span>
    <span slot="actions" slot-scope="props">
      <router-link
        :to="{
           name: 'EditQuestion',
           params: { questionId: props.row.id, id: String(campaignId) }
         }"
      >
        <i class="mdi mdi-pencil text-inverse m-r-10"></i>
      </router-link>
      <confirm-button @confirm="removeQuestion" :data="props.row.id" />
    </span>
  </data-table>
</template>
<script>
import DataTable from '@/components/DataTable';
import ConfirmButton from '@/components/ConfirmButton';
import QUESTIONS from '@/graphql/Questions/Questions.gql';
import DELETE_QUESTION from '@/graphql/Questions/DeleteQuestion.gql';
import ORDER_QUESTIONS from '@/graphql/Questions/OrderQuestions.gql';
import { success, error } from '@/helpers/notifications';

export default {
  components: {
    DataTable,
    ConfirmButton,
  },
  props: {
    campaignId: {
      type: Number,
      required: true,
    },
  },
  computed: {
    queryColumns: () => [
      { field: 'fieldName', title: 'Field Name' },
      { field: 'question', title: 'Question' },
      { field: 'type', title: 'Type' },
      { field: 'mandatory', title: 'Mandatory' },
      { field: 'created', title: 'Created' },
      { field: 'actions', title: 'Actions' },
    ],
    QUESTIONS: () => QUESTIONS    
  },
  methods: {
    onQuestionsOrdered(affrectedItems) {
      const items = affrectedItems.map(item => ({
        id: item.id,
        order: item.order,
      }));

      this.$apollo.mutate({
        mutation: ORDER_QUESTIONS,
        variables: {
          input: items,
        },
      });
    },
    async removeQuestion(id) {
      try {
        await this.$apollo.mutate({
          mutation: DELETE_QUESTION,
          variables: {
            id,
          },
          refetchQueries: ({ data }) => (data.deleteQuestion.success ? ['questions'] : []),
        });
        this.$notify(success('Question was removed'));
      } catch (e) {
        this.$notify(error(e.message));
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/Campaigns/Details/LeadForm.vue